module.exports = __webpack_public_path__ + "img/logo5.8163d737.png";